/**
 * Paradot Form Modal Utility
 * Handles the creation and management of the Paradot form modal
 */

/**
 * Create the modal HTML markup
 * @param {string} formUrl - The URL of the Paradot form
 * @returns {string} HTML markup for the modal
 */
export function createModalMarkup(formUrl) {
    return `
        <div class="paradot-modal">
            <div class="paradot-modal__header">
                <h3 class="paradot-modal__title">Calculate Your Gains</h3>
                <button class="paradot-modal__close" aria-label="Close modal">×</button>
            </div>
            <div class="paradot-modal__content">
                <iframe
                    src="${formUrl}"
                    class="paradot-modal__iframe"
                    title="Paradot Form"
                    frameborder="0"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    `;
}


/**
 * Map calculator data to Pardot form field names
 * @param {Object} paradotData - Calculator and UTM data
 * @returns {Object} - Mapped form fields with Pardot field names
 */
function mapDataToFormFields(paradotData) {
    return {
        // UTM fields - exact field names from form HTML
        '52162_379128pi_52162_379128': paradotData.utm_source || '',     // utm_source
        '52162_379125pi_52162_379125': paradotData.utm_medium || '',     // utm_medium
        '52162_379122pi_52162_379122': paradotData.utm_campaign || '',   // utm_campaign
        '52162_379131pi_52162_379131': paradotData.utm_term || '',       // utm_term
        '52162_379119pi_52162_379119': paradotData.utm_content || '',    // utm_audience/content

        // Calculator input fields
        '52162_383802pi_52162_383802': paradotData.roi_cases_per_year || '',      // cases per year
        '52162_382153pi_52162_382153': paradotData.roi_processing_hours || '',   // processing hours
        '52162_382150pi_52162_382150': paradotData.roi_analysis_hours || '',     // analysis hours

        // Calculator result fields
        '52162_382156pi_52162_382156': paradotData.roi_hours_saved || '',        // total hours saved
        '52162_382159pi_52162_382159': paradotData.roi_value_created || '',      // total value created
        '52162_382162pi_52162_382162': paradotData.roi_calc_results_links || '',  // results link


        '52162_383736pi_52162_383736': paradotData.roi_calc_results_links || '' // ROI_Calculator_Link
    };
}

/**
 * Open Paradot form in a modal
 * @param {string} formUrl - The URL of the Pardot form
 * @param {Object} paradotData - Data to send to Paradot
 * @param {string} redirectUrl - URL to redirect to after form submission
 * @param {Function} getResultsPageURL - Function to get url to redir page
 * @param {Function} redirectToResultsPage - Function to redirect to results page
 */
export function openParadotModal(formUrl, paradotData, redirectUrl, getResultsPageURL, redirectToResultsPage) {
    // Create modal overlay
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'paradot-modal-overlay';

    modalOverlay.innerHTML = createModalMarkup(formUrl);

    document.body.appendChild(modalOverlay);

    const closeBtn = modalOverlay.querySelector('.paradot-modal__close');
    const iframe = modalOverlay.querySelector('.paradot-modal__iframe');

    const closeModal = () => {
        window.removeEventListener('message', handleMessage);
        document.body.removeChild(modalOverlay);
        document.body.style.overflow = 'unset';

        console.log(getResultsPageURL(redirectUrl, paradotData));
    };

    const handleFormSubmit = () => {
        closeModal();
        redirectToResultsPage(redirectUrl, paradotData);
    };

    // Event listeners
    closeBtn.addEventListener('click', closeModal);

    iframe.addEventListener('load', () => {
        setTimeout(() => {
            const formFields = mapDataToFormFields(paradotData);
            console.log('sent fields to parform', formFields);

            iframe.contentWindow.postMessage({
                action: 'fillForm',
                fields: formFields
            }, '*');
        }, 1000);
    });

    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            closeModal();
        }
    });

    const handleEscape = (e) => {
        if (e.key === 'Escape') {
            closeModal();
            document.removeEventListener('keydown', handleEscape);
        }
    };
    document.addEventListener('keydown', handleEscape);

    const handleMessage = (event) => {
        if (event.data && event.data.action === 'PARDOT_FORM_SUCCESS') {
            console.log('Received PARDOT_FORM_SUCCESS', getResultsPageURL(redirectUrl, paradotData));
            handleFormSubmit();
            return;
        }
    };
    window.addEventListener('message', handleMessage);

    document.body.style.overflow = 'hidden';
}
